import './site-chrome.css';
import { initializeGoogleAnalytics } from './analytics';
import { publicCatalogItems, type CatalogItem } from './catalog';

initializeGoogleAnalytics();

type SiteBrandOptions = {
  readonly current?: boolean;
  readonly className?: string;
};

type RelatedToolsOptions = {
  readonly heading?: string;
  readonly openInNewTab?: boolean;
};

function escapeHtml(value: string): string {
  return value.replace(/[&<>'"]/g, (character) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;',
  })[character]!);
}

function kindLabel(kind: CatalogItem['kind']): string {
  if (kind === 'game') return '게임';
  if (kind === 'toy') return '놀이';
  return '도구';
}

export function siteBrandMarkup(options: SiteBrandOptions = {}): string {
  const className = ['site-brand-wordmark', options.className].filter(Boolean).join(' ');
  return `<a class="${className}" href="/"${options.current ? ' aria-current="page"' : ''}>오늘툴</a>`;
}

function relatedCardMarkup(item: CatalogItem, openInNewTab: boolean): string {
  const target = openInNewTab ? ' target="_blank" rel="noopener noreferrer"' : '';
  const targetCopy = openInNewTab ? ' 새 탭에서 열기' : '';
  return `
    <a class="site-related-card site-related-${item.tone}" href="${item.href}"${target} aria-label="${escapeHtml(item.title)}${targetCopy}">
      <span class="site-related-icon" aria-hidden="true">${escapeHtml(item.title.slice(0, 1))}</span>
      <span class="site-related-copy">
        <small>${kindLabel(item.kind)}</small>
        <strong>${escapeHtml(item.title)}</strong>
        <span>${escapeHtml(item.description)}</span>
      </span>
      <span class="site-related-arrow" aria-hidden="true">→</span>
    </a>`;
}

export function relatedToolsMarkup(currentSlug: string, options: RelatedToolsOptions = {}): string {
  const items = publicCatalogItems().filter((item) => item.slug !== currentSlug);
  if (items.length === 0) return '';
  const headingId = `site-related-title-${currentSlug}`;
  const heading = options.heading ?? '다른 오늘툴도 바로 열어보세요';
  return `
    <section class="site-related-tools" aria-labelledby="${headingId}">
      <div class="site-related-heading">
        <span>다른 오늘툴</span>
        <h2 id="${headingId}">${escapeHtml(heading)}</h2>
      </div>
      <div class="site-related-grid">
        ${items.map((item) => relatedCardMarkup(item, options.openInNewTab ?? false)).join('')}
      </div>
      <a class="site-related-all" href="/">오늘툴 전체 보기 <span aria-hidden="true">→</span></a>
    </section>`;
}
